import Box from '@mui/material/Box';
import { SectionTitle, BodyText } from '../components/SectionPrimitives';
import { color } from '@/themes/color';
import { typography } from '@/themes/typography';

export function Section6(): JSX.Element {
  return (
    <Box sx={{ mb: '24px' }}>
      <SectionTitle>6. Warranty Disclaimer</SectionTitle>
      <BodyText>
        UKVG provides the platform and all associated services on an "as is" and
        "as available" basis. To the fullest extent permitted by law, UKVG makes
        no representations or warranties, express or implied, including but not
        limited to:
      </BodyText>
      <Box
        component="ul"
        sx={{
          marginBottom: '16px',
          marginTop: 0,
          color: color.charcoal.default,
          ...typography.bodyText,
          display: 'block',
        }}
      >
        {[
          "that the platform will meet the Partner's specific business requirements or objectives;",
          'that use of the platform will result in any particular level of visitor traffic, bookings, enquiries, sales, or revenue;',
          'that the platform will be free from errors, interruptions, or data loss at all times;',
          'that any editorial content, curated guides, or promotional campaigns will generate a specific commercial outcome for the Partner.',
        ].map((item) => (
          <li key={item} style={{ marginBottom: '8px', lineHeight: '1.7' }}>
            {item}
          </li>
        ))}
      </Box>
      <BodyText>
        The Partner acknowledges that all digital marketing and listing services
        are provided on a best-endeavours basis and that results will vary
        depending on factors outside UKVG's control, including consumer
        behaviour, market conditions, and third-party platform performance.
      </BodyText>
      <BodyText>
        UKVG warrants that it will perform its services with reasonable care and
        skill, in accordance with applicable UK law.
      </BodyText>
    </Box>
  );
}
